export enum ComplementaryOperation {
    ATTACH = 'operation.entity.complementary.attach',
    CREATE = 'operation.entity.complementary.create',
    DELETE = 'operation.entity.complementary.delete',
    EDIT = 'operation.entity.complementary.edit',
    REMOVE_VALIDATION = 'operation.entity.complementary.remove-validation',
    VALIDATE = 'operation.entity.complementary.validate'
}
